import { isNlt, isNltBrumbrum } from '../nltUtils'

export const slugify = value =>
  `service_${value
    .replace(/[^a-zA-Z0-9 ]/g, '')
    .replace(/ /g, '_')
    .toLowerCase()}`

export function getSelectedVasPrices(product, ordineState, nltState) {
  const selected = {}

  if (!isNlt(product?.linea_prodotto)) {
    for (const vas of ordineState.servizi_extra?.ordini_servizi || []) {
      selected[slugify(vas.titolo)] = vas.prezzo
    }
  }

  if (isNlt(product?.linea_prodotto) && !isNltBrumbrum(product)) {
    for (const vasId of nltState.serviziPlusSelected || []) {
      const vas = nltState.serviziPlus?.find(item => vasId === item.id_servizio)
      selected[slugify(vas.tipologia)] = parseFloat(vas.canone_extra)
    }
  }

  return selected
}
